import React, { useState } from 'react';
import { motion } from 'framer-motion';

const EASE = [0.16, 1, 0.3, 1];

export default function EditorialLink({
  number,
  icon,
  children,
  onClick,
  bouncyIcon = false,
  'aria-label': ariaLabel,
}) {
  const [focused, setFocused] = useState(false);
  return (
    <motion.button
      type="button"
      onClick={onClick}
      aria-label={ariaLabel}
      onFocus={() => setFocused(true)}
      onBlur={() => setFocused(false)}
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: EASE }}
      whileHover="hover"
      whileTap={{ scale: 0.97 }}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 10,
        background: 'none',
        border: 'none',
        padding: '12px 0',
        minHeight: 48,
        fontFamily: 'var(--mono)',
        fontSize: 'clamp(10px, 0.85vw, 12px)',
        letterSpacing: '0.28em',
        textTransform: 'uppercase',
        color: 'rgba(255,255,255,0.75)',
        cursor: 'none',
        position: 'relative',
      }}
    >
      <span style={{ opacity: 0.5 }}>[{number}]</span>
      <motion.span
        aria-hidden="true"
        animate={bouncyIcon ? { y: [0, 4, 0] } : undefined}
        transition={bouncyIcon ? { duration: 2.4, repeat: Infinity, ease: 'easeInOut' } : undefined}
        style={{ display: 'inline-flex' }}
      >
        {icon}
      </motion.span>
      <span>{children}</span>
      <motion.span
        aria-hidden="true"
        variants={{
          hover: { width: '100%', opacity: 1 },
        }}
        initial={{ width: 0, opacity: 0.6 }}
        animate={focused ? { width: '100%', opacity: 1 } : undefined}
        transition={{ duration: 0.35, ease: EASE }}
        style={{
          position: 'absolute',
          left: 0,
          bottom: 8,
          height: 1,
          background: 'rgba(255,255,255,0.6)',
        }}
      />
    </motion.button>
  );
}
